var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComputer = function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.357 0H.645A.637.637 0 0 0 0 .627v12.55c0 .347.289.628.645.628H5.42c0 .692-.578 1.255-1.29 1.255V16h7.74v-.94c-.712 0-1.29-.563-1.29-1.255h4.775a.637.637 0 0 0 .645-.628V.627A.634.634 0 0 0 15.357 0Zm-7.84 12.394c0-.26.216-.47.483-.47s.483.21.483.47-.216.47-.483.47a.477.477 0 0 1-.483-.47ZM.968 10.982V.942h14.067v10.04H.968Z"
  })));
};

export default SvgComputer;